import React from "react"
import { Link } from "gatsby"

import Bio from "../bio"
import Head from "../head"
import { PostHeader } from "./header"
import { PostBody } from "./blog-body"
import { PostFooter } from "./footer"
import { getThumbnailImage } from "../../utils/event-manager"

import "./index.scss"

const BlogPost = ({ html, frontmatter, description, pageContext, sponsor, utterances }) => {

    const { title, date, category, tags } = frontmatter
    const icon = getThumbnailImage(html)
  
    return (
      <div>
        <Head
          title={title}
          category={category}
          tags={tags}
          description={description}
          icon={icon}
        />
        <PostHeader title={title} date={date}></PostHeader>
        <div className={"post-wrap"}>
          <PostBody html={html} sponsor={sponsor}></PostBody>
          <Bio />
          <PostFooter
            pageContext={pageContext}
            utterances={utterances}
          ></PostFooter>
        </div>
      </div>
    )
}

export default BlogPost
